import { Lightning, Registry } from '@lightningjs/sdk'
import { getColor, grey50, grey920, transparent } from '../../constants/colors'
import { UniNeueBold } from '../../constants/fonts'
import { getAsset } from '../../utils/image'

const FADE_ANIM_TIME = 1.5 // in seconds

export default class ToastNotification extends Lightning.Component {
  private _toastTimerId = -1
  private _animationFadeOut: Lightning.Animation
  private _animationFadeIn: Lightning.Animation

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: transparent,
      flex: { justifyContent: 'flex-end' },
      Container: {
        w: 550,
        h: 60,
        rect: true,
        color: getColor(grey50),
        alpha: 0,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 8,
        },
        flexItem: {
          margin: 40,
        },
        flex: {
          direction: 'row',
          alignItems: 'center',
        },
        Icon: {
          color: getColor(grey920),
          flexItem: {
            marginLeft: 15,
          },
        },
        Message: {
          w: 530,
          h: 36,
          flexItem: {
            marginLeft: 5,
          },
          text: {
            textColor: getColor(grey920),
            fontSize: 28,
            fontFace: UniNeueBold,
            text: '',
            verticalAlign: 'middle',
            letterSpacing: 0.48,
          },
        },
      },
    }
  }

  get icon() {
    return this.tag('Icon')
  }

  get message() {
    return this.tag('Message')
  }

  set data(data: ToastNotificationParams) {
    this.setMetadata(data)
  }

  async setMetadata({ message, icon, timeout }) {
    this.message.text.patch({
      text: message,
    })

    this.icon.patch({ texture: Lightning.Tools.getSvgTexture(getAsset(icon), 40, 40) })

    if (this._toastTimerId >= 0) {
      Registry.clearTimeout(this._toastTimerId)
    }

    this._toastTimerId = Registry.setTimeout(() => {
      this._animationFadeOut.replay()
    }, timeout)
    this._animationFadeIn.replay()
  }

  _setup() {
    this._animationFadeIn = this.animation({
      duration: FADE_ANIM_TIME,
      actions: [{ t: 'Container', p: 'alpha', rv: 1, v: { 0: { v: 0 }, 1: { v: 1 } } }],
    })

    this._animationFadeOut = this.animation({
      duration: FADE_ANIM_TIME,
      actions: [{ t: 'Container', p: 'alpha', rv: 0, v: { 0: { v: 1 }, 1: { v: 0 } } }],
    })
  }

  _disable() {
    Registry.clearTimeout(this._toastTimerId)
  }
}
